import { render, staticRenderFns } from "./workorder-detail-modal.vue?vue&type=template&id=76af9cb5&"
import script from "./workorder-detail-modal.vue?vue&type=script&lang=js&"
export * from "./workorder-detail-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports